import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IEssentialsModule } from '@devinforius/i-essentials';
import { ToastModule } from 'primeng/toast';
import { IViewerModule } from '@devinforius/i-viewer';
import { ITableModule } from '@devinforius/i-table';
import { IMapModule } from '@devinforius/i-map';
import { IAccordionModule } from '@devinforius/i-accordion';
import { IFileModule } from '@devinforius/i-file';
import { IDataModule } from '@devinforius/i-data';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { SliderModule } from 'primeng/slider';
import { TextareaModule } from 'primeng/textarea';
import { PictureStripComponent } from './components/picture-strip/picture-strip.component';
import { PictureViewerComponent } from './components/picture-viewer/picture-viewer.component';
import { RefusalReasonModalComponent } from './components/refusal-reason-modal/refusal-reason-modal.component';

@NgModule({
  declarations: [
    PictureStripComponent,
    PictureViewerComponent,
    RefusalReasonModalComponent,
  ],
  // IEssentialsModule est aussi importé (pas seulement réexporté) pour garantir
  // l'enregistrement de ses providers (providePrimeNG/Inforius, ConfirmationService...).
  // FormsModule + SliderModule : requis par le p-slider (ngModel) de PictureViewerComponent.
  // ReactiveFormsModule + TextareaModule : requis par le textarea de RefusalReasonModalComponent.
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ConfirmPopupModule,
    IEssentialsModule,
    SliderModule,
    TextareaModule,
  ],
  exports: [
    IEssentialsModule,
    IViewerModule,
    ITableModule,
    IMapModule,
    IAccordionModule,
    IFileModule,
    IDataModule,
    ToastModule,
    ConfirmPopupModule,
    SliderModule,
    TextareaModule,
    PictureStripComponent,
    PictureViewerComponent,
    RefusalReasonModalComponent,
  ],
})
export class SharedModule {}
